import { render, staticRenderFns } from "./TipsEncouragementListView.vue?vue&type=template&id=385112fc&scoped=true"
import script from "./TipsEncouragementListView.vue?vue&type=script&lang=js"
export * from "./TipsEncouragementListView.vue?vue&type=script&lang=js"
import style0 from "./TipsEncouragementListView.vue?vue&type=style&index=0&id=385112fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385112fc",
  null
  
)

export default component.exports